import { useGlobalInfluencerFilter } from "@/contexts/GlobalInfluencerFilterContext";
import { Filter } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ActiveFilterBadge() {
  const { hasAnyFilter, qualifyingCount, totalCount } = useGlobalInfluencerFilter();
  const navigate = useNavigate();

  if (!hasAnyFilter) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2 mb-4 rounded-lg border border-primary/20 bg-primary/5 text-sm">
      <Filter className="w-3.5 h-3.5 text-primary shrink-0" />
      <span className="text-muted-foreground">
        Showing{" "}
        <span className="font-mono font-semibold text-primary">{qualifyingCount}</span>
        <span className="font-mono">/{totalCount}</span>
        {" "}influencers
      </span>
      <button
        onClick={() => navigate("/leaderboard")}
        className="text-xs text-primary hover:text-primary/80 underline underline-offset-2 transition-colors"
      >
        Edit filters
      </button>
    </div>
  );
}
